export const project = 'shiftDr'; // need this for when we dynamically import utils

export const sending = ({ data, preview, win, flags }) => {
	if (!flags['ws-tagging-shift-dr-disabled']) {
		const { events, digRet, ...rest } = data;
		const reportsForEventViewer = [
			{
				events,
				name: project,
				payload: {
					digRet,
					...rest
				},
				sender: 'sd'
			}
		];
		const reportsForNewRelic = [
			{
				clientEventName: events,
				sender: 'win.sd'
			}
		];

		if (!preview && win.sd) {
			win.sd('dataLayer', data);
			win.sd('send');
		}

		return {
			reportsForEventViewer,
			reportsForNewRelic
		};
	}
	return {
		reportsForEventViewer: [],
		reportsForNewRelic: []
	};
};

export const vehicleStatus = ({ vehicles }) => {
	const vehicle = vehicles[0];
	if (vehicle.newOrUsed.toUpperCase() === 'NEW') {
		return 'New';
	} else if (vehicle.newOrUsed.toUpperCase() === 'USED') {
		if (vehicle.certified.toUpperCase() === 'CERTIFIED') {
			return 'CPO';
		} else {
			return 'Used';
		}
	} else {
		return '';
	}
};

export const isGtp = ({ eventData }) => {
	if (window.DDC.dataLayer.site.profiles.includes('subaruprofile')) {
		if (eventData?.sourceData?.tradeInSource === 'SUBARUGTP') {
			return 'true';
		}
		return 'false';
	}
	return '{{REMOVEKEY}}';
};
